import React, { useState, Fragment } from "react";
import MaterialTable, { MTableAction } from "material-table";
import { Button } from "@material-ui/core";
import AgregarPermiso from "../agregarPermiso";
import MenuDropdown from "../../../../components/menuDropDown";
import { MoreVert as MoreVertIcon } from "@material-ui/icons";
import EditarPermiso from "../editPermiso";
import EliminarPermiso from "../eliminarPermiso";

const location = require('../../../../data/location.json');


function Page(props) {
  const { data, isLoading, onClickOpenAddPermiso, onClickOpenDeletePermiso, onClickOpenEditPermiso } = props;
  const [pageSize, setPageSize] = useState(10);
  return (
    <Fragment>
      <MaterialTable
        title={`Listado de Permisos`}
        data={data}
        options={{
          filtering: false,
          pageSizeOptions: [5, 10, 20, 50],
          pageSize: pageSize,
          grouping: false,
          columnsButton: true,
          maxBodyHeight: "70vh",
          headerStyle: {
            textAlign: 'center',
            border: "1px solid #E0E0E0",
            fontWeight: 'bold',
            color: '#731f1f',
            position: 'sticky'
          },
          rowStyle: {
            border: "1px solid #E0E0E0"
          },
          padding: 'dense',
          actionsCellStyle: {
            width: "2%",
            textAlign: "center",
            border: "1px solid #E0E0E0",
          },
          cellStyle: {
            border: "1px solid #E0E0E0",
          }
        }}
        onChangeRowsPerPage={size => { setPageSize(size) }}
        localization={location}
        isLoading={isLoading}
        columns={[
          {
            title: 'Nombre',
            field: 'nombre',
          },
          {
            title: 'Descripción',
            field: 'descripcion',
          }
        ]}
        actions={[
          {
            icon: "settings",
            onClick: (evt) => { }
          },
          {
            icon: "agregar",
            isFreeAction: true,
            onClick: (evt) => { }
          },
        ]}
        components={{
          Action:
            props => {
              const rowData = props.data;
              if (props.action.icon === 'agregar') {
                return (
                  <Button
                    variant="outlined"
                    onClick={(evt) => onClickOpenAddPermiso(evt, null)}
                  >
                    Agregar Permiso
                  </Button>
                );
              }
              if (props.action.icon === 'settings') {
                const accionesConfiguracion = [
                  {
                    content: 'Eliminar',
                    onClick: (e) => onClickOpenDeletePermiso(rowData)
                  },
                  {
                    content: 'Editar',
                    onClick: (e) => onClickOpenEditPermiso(rowData)
                  }
                ];

                return (<MenuDropdown
                  icon={
                    <MoreVertIcon />
                  }
                  tooltip="Opciones"
                  items={accionesConfiguracion}
                  hidden={accionesConfiguracion.length <= 0}
                />);
              }
              return (<MTableAction {...props} />);
            }
        }}
      />
      <AgregarPermiso />
      <EditarPermiso />
      <EliminarPermiso />
    </Fragment>
  );
}

export default Page;